import {
  Column,
  Row,
  StackedCell,
  StackedCellDescription,
  StackedCellValue,
  StackedSection,
  StackedTable,
  Text,
} from "@amzn/meridian";
import React from "react";
import "./stateTree.scss";
import { TextTurn } from "../../../types";

interface StateTreeProps {
  selectedTurn: TextTurn;
}
const StateTree = ({ selectedTurn }: StateTreeProps) => {
  const renderValue = (value: any) => {
    // if the value is a date, render it in a human readable format
    if (typeof value === "string") {
      if (!isNaN(+value)) {
        console.log(value);
        return value;
      }

      if (!isNaN(new Date(value)?.getTime())) {
        const date = new Date(value);
        return `${date.toLocaleDateString()}`;
      }

      // format the value
      return value.replaceAll("_", " ").trim();
    }

    return JSON.stringify(value);
  };

  const renderStateTree = (tree: object, level = 0) => {
    if (!tree) {
      return <Text>N/A</Text>;
    }
    return (
      <>
        {Object.keys(tree).map((key) => {
          const isObject = typeof tree[key] === "object" && !!tree[key];
          const hasChildren = isObject && Object.keys(tree[key]).length > 0;
          // prune empty nodes
          if (isObject && !hasChildren) return;
          // recursively build tree
          return (
            <>
              {hasChildren ? (
                <>
                  <div className="state-tree__node-container">
                    <Row
                      type="fill"
                      width={"fill"}
                      spacingInset={"300"}
                      className="state-tree__node"
                    >
                      <Text type="h100" transform="capitalize">
                        {renderValue(key)}
                      </Text>
                    </Row>
                  </div>
                  <div className="state-tree__node-list">
                    {renderStateTree(tree[key], level + 1)}
                  </div>
                </>
              ) : (
                <div className="state-tree__node-container">
                  <Row
                    width={"fill"}
                    spacing={"300"}
                    type="outline"
                    spacingInset={"200 300"}
                    className="state-tree__node"
                  >
                    {
                      // only render the key if it's not a number - the key will be numeric for arrays
                      isNaN(parseInt(key)) && (
                        <Text type="h100" transform="capitalize">
                          {renderValue(key)}:
                        </Text>
                      )
                    }

                    {tree[key] ? (
                      <Text transform="capitalize">
                        {renderValue(tree[key])}
                      </Text>
                    ) : (
                      <Text className="state-tree__null" color="secondary">
                        N/A
                      </Text>
                    )}
                  </Row>
                </div>
              )}
            </>
          );
        })}
      </>
    );
  };

  return (
    <Column className="state-tree">
      <StackedTable showBorder showRowDividers>
        <StackedSection titleLevel={5} title="Type">
          <StackedCell>
            <StackedCellValue>
              {renderValue(selectedTurn.responseDetails.type).toUpperCase()}
            </StackedCellValue>
            <StackedCellDescription>
              One of CONFIRMATION, FOLLOW UP, or OUT OF SCOPE
            </StackedCellDescription>
          </StackedCell>
        </StackedSection>
        <StackedSection titleLevel={5} title="State">
          <StackedCell>
            <StackedCellValue>
              {selectedTurn.responseDetails?.state ? (
                <div className="state-tree__node-list">
                  {renderStateTree(selectedTurn.responseDetails?.state)}
                </div>
              ) : (
                <Text color="secondary" className="state-tree__null">
                  N/A
                </Text>
              )}
            </StackedCellValue>
          </StackedCell>
        </StackedSection>
      </StackedTable>
    </Column>
  );
};

export default StateTree;
